<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            Modification de l'entité<strong> {{entity.nom_commercial}}</strong>  
          </div>
          <b-row class="form-group">
            <b-col md="6">
              <label for="gerant">Gérant </label>
              <b-form-input type="text" v-model="entity.gerant" placeholder="gerant"></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="nom_commercial">Nom commercial</label>
              <b-form-input type="text" v-model="entity.nom_commercial" placeholder="Nom Commercial"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <!-- <b-col md="6">
              <label for="solde">Solde</label>
              <b-form-input type="text"  v-model="entity.solde" placeholder="Solde"></b-form-input>
            </b-col> -->
            <b-col md="6">
              <label for="type">Type</label>
              <b-form-select id="type" :plain="true" :options="options" v-model="entity.typeentite_libelle">
              </b-form-select>
            </b-col>
            <b-col md="6">
              <label for="email">Email</label>
              <b-form-input type="text"  v-model="entity.email" placeholder="Email"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="6">
              <label for="telephone">Téléphone</label>
              <b-form-input type="text" v-model="entity.telephone" placeholder="Telephone"></b-form-input>
            </b-col>
            
            <b-col md="12">
              <label for="description">Description</label>
               <textarea id="description" placeholder="Description" v-model="entity.description" rows="3" max-rows="6" class="form-control"></textarea>
            </b-col>
          </b-row>
          <div slot="footer">
            <span v-if="can('entite-edit')"><b-button type="submit" size="sm" variant="primary" @click.prevent="put()"><i class="fa fa-dot-circle-o"></i> Valider</b-button></span>
            <span><b-button type="reset" size="sm" variant="danger" @click="goBack"><i class="fa fa-ban"></i> Annuler </b-button></span>
          </div>
        </b-card>    
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'tables',
  props:{
    id:Number
  },
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      options : [],
      entity:{
            nom_commercial: '',
            
            email: '',
            telephone: '',
            typeentite_libelle: '',
            gerant: '',
            email: '',
            description: '',
            _method:'put'
      }
    }
  },
  methods:{
    countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    goBack() {
      this.$router.go(-1)
    },
    async put(){     
        this.response = await this.$store.dispatch('entity/put_entity',{id:this.$route.params.id,entity:this.entity})
        this.showAlert()
    },
    async displayEntity(){
        let response = await this.$store.dispatch('entity/show_entites',this.$route.params.id)
        //console.log('ee ',response.typeentite_libelle)
        this.entity.nom_commercial = response.nom_commercial,
        // this.entity.solde = response.solde,
        this.entity.email = response.email,
        this.entity.telephone = response.telephone,
        this.entity.typeentite_libelle = response.typeentite_libelle,
        this.entity.gerant = response.gerant,
        this.entity.email = response.email,
        this.entity.description = response.description
    },
    async get_all_typesentite(){
      await this.$store.dispatch('entity/get_all_typesentite').then(()=>{
        store.getters['entity/types'].forEach(element => {
          this.options.push({
            value:element.libelle,
            text:element.libelle.toUpperCase()
          })
        });
      })
    },
    reset(){
            this.entity.nom_commercial= '',
            this.entity.solde= '',
            this.entity.email= '',
            this.entity.telephone= '',
            this.entity.typeentite_libelle= '',
            this.entity.gerant= '',
            this.entity.email= '',
            this.entity.description=''
    },
    can(perm){
        return store.getters['auth/can'](perm)
    }
  },
  mounted(){
    this.displayEntity()
    this.get_all_typesentite()
  }
}
</script>
